<script>
	import formBase from '@_system/components/base/form.vue'
	import logisticsBox from './box/logistics.vue'
	import configIndex from './config/index.vue'
	export default {
		extends: formBase,
		name: 'expresscompanyForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 	
				<logistics-box ref="logisticsbox" onSubmit = {this.logisticsboxSubmit} />, 
				<config-index ref="configindex" configjson={this.configjson} row={this.currentrow} onSuccess = {this.configSuccess}  />, 
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {
				handle:null,
				currentrow:{},
				configjson:null,
				aftertabledataload:{
					$son_expresscompany_detail(e){
						e.data.forEach((item)=>{
							item.config = item.config?JSON.stringify(item.config):null
						})
					}
				}
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			beforeSubmit(formData, next) {
				formData.config = formData.config?JSON.parse(formData.config):null
				console.log(formData)
				for(let i in formData.$son_expresscompany_detail){
					formData.$son_expresscompany_detail[i].forEach((item)=>{
						item.config = item.config?JSON.parse(item.config):null
					})
				}
				next()
			},
			beforeInit(next){
				next()
			},
			beforeRender(sourceData){
				sourceData.config = sourceData.config ? JSON.stringify(sourceData.config) : null
			},
			tableAdd(e) {
				this.$refs.logisticsbox.initList()
				this.$refs.logisticsbox.box.alertBox()
				this.handle = e
			},
			logisticsboxSubmit(e){
				this.handle.obj = e.data.map((item)=>{
					return {
						logisticsid:item.unitUid,
						logisticsname:item.distrName,
						distrname:item.distrParamName
					}
				})
				if(this.handle.obj.length){
					this.handle.next()
				}
				
			},
			configButton(){
				this.configjson = this.fApi.getValue('config') ? this.fApi.getValue('config') : null
				this.currentrow = {}
				this.config()
			},
			regestEvent(rule,fApi) {
				let $son_expresscompany_detail = fApi.el('$son_expresscompany_detail')
				$son_expresscompany_detail.config = (row)=>{
					this.currentrow = row
					this.configjson = row.config ? row.config : ( this.fApi.getValue('config') ? this.fApi.getValue('config') : null )
					this.config()
				}
			},
			config(){
				this.configjson = this.configjson ? JSON.parse(this.configjson) : {}
				this.$nextTick(()=>{					
					this.$refs.configindex.modal_show()
				})
			},
			configSuccess(e){
				//console.log(e)
				if(!e.logisticsid){
					this.fApi.setValue('config',e.data)
				}else{
					let data = this.getTableData('expresscompany_detail','fullData')
					data.forEach((item)=>{
						if(item.logisticsid == e.logisticsid){
							item.config = e.data
						}
					})
					
				}
			}
		},
		components: {
			logisticsBox,
			configIndex
		}
	}
</script>
